module.exports = "<div class=\"align-content-center col-lg-10 spaces\">\n  <p>{{participant.firstName}} {{participant.lastName}} - {{participant.affiliation}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/participants/participant/participant.component.html
// module id = ../../../../../src/app/participants/participant/participant.component.html
// module chunks = main